import React from 'react';
import Button from '@alltrails/shared/denali/components/Button';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { StringConstantsMixin } from './mixins/shared/string_constants_mixin';
import * as styles from './connectButtonStyles.module.scss';

const createReactClass = require('create-react-class');

const ConnectAppleButton = createReactClass({
  componentDidMount() {
    ServerCommunicationUtil.initApple(this.props.authState);
  },
  handleUnlinkClick() {
    ServerCommunicationUtil.postApiEndpoint(this.props.unlinkPath, {});
  },
  render() {
    let button;
    if (this.props.appleSigninId) {
      button = (
        <li className="mark no-underline">
          <form id="connect-apple-form" className={styles.connectButton} onSubmit={this.handleUnlinkClick}>
            {StringConstantsMixin.strings.SIGNUP.CONNECTED}
            <Button text={StringConstantsMixin.strings.SIGNUP.UNLINK} type="submit" size="sm" variant="destructive" />
          </form>
        </li>
      );
    } else {
      button = (
        <a className="account-settings flat-apple-btn apple">
          <div>
            <span>{StringConstantsMixin.strings.SIGNUP.CONNECT_WITH_APPLE}</span>
          </div>
        </a>
      );
    }
    return <ul className="sidebar-facebook">{button}</ul>;
  }
});

export { ConnectAppleButton };
